import { useState, type ReactNode } from 'react';

/** An image that falls back to a second address, as the app falls back from its CDN copy. */
export function FallbackImage({
  src,
  fallbackSrc,
  alt = '',
  className,
  missing,
}: {
  src?: string | null;
  fallbackSrc?: string | null;
  alt?: string;
  className?: string;
  /** Shown when neither address gives an image. */
  missing: ReactNode;
}) {
  const [failed, setFailed] = useState<string[]>([]);
  const shown = [src, fallbackSrc].find((url): url is string => !!url && !failed.includes(url));
  if (!shown) return <>{missing}</>;
  return (
    <img
      src={shown}
      alt={alt}
      className={className}
      onError={() => setFailed((all) => [...all, shown])}
    />
  );
}
